import styled from 'styled-components';

const Header = styled.div`
  position: absolute;
  height: 200px;
  width: 100%;
  top: 0;
  background-image: linear-gradient(to right,#282B2C, #006D99, #282B2C);
  background-size: 100% 100%;
`;

export default Header;
